import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-selected-background-check',
  templateUrl: './selected-background-check.component.pug',
  styleUrls: ['./selected-background-check.component.scss'],
  standalone: false
})
export class SelectedBackgroundCheckComponent implements OnInit {
  @Input() selectedBackgroundChecks: any;
  @Input() selectedFlow: any;
  @Input() selectedFlows: any;
  @Input() disable_edit= false;
  @Output() removeCheck = new EventEmitter();

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
  }

  removeSelectedCheck(check) {
    this.removeCheck.emit(check)
  }

  formatData(categories: string[]): string {
    return categories.join(', ');
  }

  getSelectedFlowName(flowId: string): string | null {
    const match = this.selectedFlows.find(f => f.parent_short === flowId);
    return match ? match.name : null;
  }



}
